// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const commonLayout = "CommonLayout__commonLayout__j3mNB";
export const isShrunkSidebar = "CommonLayout__isShrunkSidebar__IPlRi";
export const header = "CommonLayout__header__yMTs0";
export const content = "CommonLayout__content__LtXyp";
export const pushFooter = "CommonLayout__pushFooter__zr+Bc";
export const buttons = "CommonLayout__buttons__V-U0Y";
export const buttonWrapper = "CommonLayout__buttonWrapper__-Z2YD";